import { Component, OnInit } from "@angular/core";
import { Names } from "../names";
import { MenuModule, MenuItem } from "primeng/primeng";

@Component({
    selector: Names.pullOutMenuLayout.selector,
    template: require("./pullOutMenuLayout.html")
})
export class PullOutMenuLayoutComponent implements OnInit {
    isPulledOut = false;
    tradingMenuItems: MenuItem[];
    technicalMenuItems: MenuItem[];

    togglePull(value: boolean): void {
        this.isPulledOut = value;
    }

    ngOnInit() {
        this.tradingMenuItems = [
            { label: "Example 1", icon: "fa-bar-chart" },
            { label: "Example 2", icon: "fa-calendar" }
        ];
        this.technicalMenuItems = [
            { label: "Area services", icon: "fa-bar-chart" },
            { label: "Contract services", icon: "fa-calendar" },
            { label: "Capacity services", icon: "fa-plug" },
            { label: "Monitor tech services", icon: "fa-calendar" }
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/PullOutMenu/PullOutMenuLayoutComponent.ts